import { AllRequestDto } from './all-request-dto.model';
import { RequestDecriptionClass } from './request-decription-class.model';


export class RequestDescriptionDto implements IRequestDescriptionDto {
    request!: AllRequestDto;
    descriptionList!: RequestDecriptionClass[] | undefined;

    constructor(data?: IRequestDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AllRequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["descriptionList"])) {
                this.descriptionList = [] as any;
                for (let item of _data["descriptionList"])
                    this.descriptionList!.push(RequestDecriptionClass.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.descriptionList)) {
            data["descriptionList"] = [];
            for (let item of this.descriptionList)
                data["descriptionList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRequestDescriptionDto {
    request: AllRequestDto;
    descriptionList: RequestDecriptionClass[] | undefined;
}

